<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    ModalUsoEquipo(:origen="origen" :config="configModal" :oficinas="oficinas" :ubicaciones="ubicaciones" :localizaciones="localizaciones" :estadosDB="estadosDB" @selectNewOffice="selectNewOffice" v-show="modalStatus")
    ModalPuestos(:puestos="puestos" :puestoUser="puestoUser" :config="configModalPuestos" @selectNewPuesto="selectNewPuesto" v-show="modalStatusPuestos")
    ModalDocumentos(v-show="modalStatusD" :tipo="tipoFileUp" :asignacion="asignacionToModal" @padre:close="cerrarModalD" @subirDocumento="subirDocumento" @borrarDocumento="verModalDeleteDocumento")
    ModalResponsiva(v-show="modalStatusResp" :usuarios="usuarios" :verBotones="verBotones" 
    :responsiva="responsivaToModal" @padre:close="cerrarModalResp" @borrarResponsiva="borrarResponsiva" 
    @borrarDocumento="verModalDeleteDocumentoFromResp" 
    @subirDocumentoFromResponsiva="subirDocumentoFromResponsiva"
    @cambiarEntrega="cambiarEntrega"
    )
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarDocumento")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title {{ title }}
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-5
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie | resguarda | ubicación | Oficina | Descripcion',
                  v-model="query_articulos",
                )
          .column.is-3.is-offset-4
            a.button.is-black(v-show="permisos.inventarios!=6" @click="irSalidas('a')")
              i.fas.fa-plus
              | &nbsp Nueva Asig.
            | &nbsp
            a.button.is-success(@click="downloadAsignaciones")
              i.fas.fa-download
              | &nbsp Descargas
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column
            .table-responsive(v-show="asignacionesShow.length > 0 && !showOtros")
              table#tbAsignaciones.table.is-striped.is-fullwidth
                thead
                  tr
                    th(v-show="verIdSAP") idSAP
                    th TAG
                    th Resguarda
                    th Ubicación
                    th Descripción
                    th Imágenes
                    th(v-show="verFacturas") Factura
                tbody
                  tr(v-for="(data, index) in asignacionesShow" :key="data.id")
                    td(v-show="verIdSAP")
                      a.button.is-black.is-rounded.is-small(@click="irAsignacionDetalle(data)") {{ data.idSAP === ''? 's/idSAP' : data.idSAP }}
                    td 
                      span.tag.is-black(v-show="data.tag !== ''")
                        | {{ data.tag }}
                    td
                      span.tag.is-black(@click="irResguardos(data.idRecibe)")
                        | {{ data.recibe }}
                      | &nbsp
                      a.button.is-small.is-danger.is-rounded(@click="printAsignacion(data)")
                        i.fas.fa-file-pdf
                      br
                      span.tag(v-show="data.puesto !== ''") {{ data.puesto }}
                      | &nbsp
                      a.button.is-warning.is-rounded.is-small(@click="verModalPuestos(data)")
                        span.icon
                          i.fa.fas.fa-pencil-alt
                      br
                      a.button.is-small.is-rounded(@click="firmar(data, 1)" :class="data.firma_entrega==='' ? 'is-warning' : 'is-success' " v-show='verFirmar && !data.inAlmacen')
                        i.fas.fa-signature
                      | &nbsp
                      a.button.is-small.is-rounded(@click="firmar(data, 2)" :class="data.firma_recibe==='' ? 'is-warning' : 'is-success' " v-show='verFirmar && !data.inAlmacen')
                        i.fas.fa-signature
                    td(@click="cambiarUbicacion(data)")
                      span.tag.is-black {{ data.destino === 'CORP' ? 'CORPORATIVO' : data.destino }}
                      br
                      span.tag {{ data.oficina }}
                    td
                      a.button.is-black.is-small.is-rounded(@click="irEditarArticulo(data)")
                        | {{ data.descripcion }}&nbsp
                      a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id_articulo)")
                        i.fas.fa-history
                      span.tag(v-show="data.responsiva !==''" :class="data.responsiva.firma_gerente === '' || data.responsiva.firma_user === '' ? 'is-warning' : 'is-success'" @click="verModalResponsiva(data)")
                        span(v-html="getDataResp(data.responsiva)")
                      span.tag.is-warning(v-show="data.tipo == 7")
                        b Pruebas&nbsp
                        i.far.fa-calendar-check
                      br
                      span.tag.is-light.is-small(v-show=" data.marca !== ''") Marca: {{ data.marca }} &nbsp&nbsp
                      span.tag.is-small(v-show=" data.modelo !== ''") Modelo: {{ data.modelo }} &nbsp&nbsp
                      span.tag.is-small(v-show=" data.serie !== ''") Serie: {{ data.serie }} &nbsp&nbsp
                      span.tag.is-light.is-small(v-show="data.tipoAdm == 2") Num. {{ data.numeroTelefono }}
                      span.tag.is-light.is-small(v-show="data.tipoAdm == 1") Placas: {{ data.placas }}
                      a.button.is-light.is-rounded.is-small(v-show="data.tipoAdm == 2" @click="verHistoriaNumero(data.numeroTelefono)")
                        i.fas.fa-history
                      br
                      span.tag.is-light.is-small(v-show="data.precioUnitario > 0") Precio Unit. {{ data.precioUnitario | currency }}
                    td
                      a.button.is-rounded.is-small(@click="verModalD(data, 'images')" :class="getClassTipo(data, '0')")
                        i.far.fa-folder-open
                        | &nbsp
                        span {{ data.documentos == 0 ? ' Sin Documentos' : ` (${(data.documentos.filter( d => d.tipo === '0')).length}) Imágenes`}}
                    td(v-show='verFacturas')
                      a.button.is-rounded.is-small(:class="data.rutaFac !== '' ? 'is-success': 'is-warning'" @click="verModalD(data, 'facturas')")
                        i.far.fa-folder-open
                        | &nbsp
                        span Factura
            TbOtrasAsignaciones(:otrasAsignaciones="otrasAsignacionesSelect" v-show='showOtros && showOtros && otrasAsignacionesSelect.length > 0' @updateUbicacion="updateUbicacion")
            TbOtrosEstados(:articulos="otrosEstados" v-show='showOtros && showOtros && otrosEstados.length > 0' @updateUbicacion="updateUbicacion")
        .columns(v-show="asignacionesSelect.length < 1")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import ModalUsoEquipo from './shared/ModalUsoEquipo.vue'
import ModalDocumentos from './shared/ModalDocumentos.vue'
import ModalYN from '@/components/shared/ModalYN.vue'
import ModalResponsiva from "@/components/responsivas_Componentes/components/ModalResponsiva.vue"
import ModalPuestos from "./shared/ModalPuestos.vue"
import TbOtrasAsignaciones from './TbOtrasAsignaciones.vue'
import TbOtrosEstados from './TbOtrosEstados.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import InventarioServices from '../../services/inventario/inventario'
import ResponsivasService from '../../services/inventario/responsivas'
import UsuariosServices from '../../services/usuarios/usuarios'


export default {
  name: 'ListaAsignaciones',
  components: { Loader, NavBarInventario, ModalUsoEquipo, TbOtrasAsignaciones, 
  ModalDocumentos, ModalResponsiva, TbOtrosEstados, ModalYN, ModalPuestos },
  data () {
    return {
      isLoading: true,
      asignaciones: [],
      asignacionesSelect: [],
      asignacionesShow: [],
      tipos: [],
      query_articulos: '',
      query: 'ALL',
      userNormal: false,
      itemCambiar: {},
      configModal: {},
      modalStatus: false,
      showOtros: false,
      verOtros: false,
      otrasAsignaciones: [],
      otrasAsignacionesSelect: [],
      verArticulosArea: false,
      result_query: '',
      verFirmar: false,
      title: '',
      modalStatusD: false,
      asignacionToModal: {},
      areaInt: 0,
      areaAdm: 0,
      verOpciones: false,
      responsivas: [],
      modalStatusResp: false,
      responsivaToModal: {},
      verBotones: false,
      otrosEstados: [],
      modalStatusYN: false,
      configModalYN: {},
      documentoSelect: {},
      verArticulosCede: false,
      tipoFileUp: '',
      isFileResponsiva: false,
      verDescargar: false,
      verIdSAP: false,
      verFacturas: false,
      modalStatusPuestos: false,
      configModalPuestos: {},
      puestos: [],
      puestoUser: {},
      sede: '',
      almacenes: [],
      origen: {},
      oficinas: [],
      ubicaciones: [
        { id: '1566247215482', nombre: 'IRGE', valor: 'IRGE' },
        { id: '1565899419222', nombre: 'TPA', valor: 'TPA' },
        { id: '1588283398540', nombre: 'CORPORATIVO', valor: 'CORPO' },
        { id: '1566322725551', nombre: 'EB04', valor: 'EB04' },
        { id: '1588173714497', nombre: 'DUCTO', valor: 'LPGD' },
        { id: '1565964784014', nombre: 'EB00', valor: 'EB00' },
        { id: '1566330159028', nombre: 'EB01', valor: 'EB01' },
        { id: '1566235785478', nombre: 'EB02', valor: 'EB02' },
        { id: '1566338236531', nombre: 'EB03', valor: 'EB03' },
        { id: '1588172064431', nombre: 'ERM-TLAUTLA', valor: 'ERM' }
      ],
      estadosDB: [],
      localizaciones: [],
      usuarios: [],
    }
  },
  watch: {
    query_articulos() {
      const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
      console.log(QUERY_ARTICULOS)
      if (this.query_articulos.length !== 0) {
        const asignFilter = this.asignacionesSelect.filter( asigns => { 
          return `${asigns.serie} ${asigns.recibe} ${asigns.ubicacion_Asig} ${asigns.oficinaArt} ${asigns.descripcion}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        console.log(asignFilter)
        this.asignacionesShow = asignFilter
        this.result_query = this.asignacionesShow.length === 1 ? `Se encontró ${this.asignacionesShow.length} coincidencia.` : `Se encontraron ${this.asignacionesShow.length} coincidencias.`
      } else {
        this.asignacionesShow = this.asignacionesSelect
        this.result_query = ''
      }
    }
  },
  methods: {
    iniciarComponente() {
      this.verIdSAP = true
      this.verFacturas = true
      this.verOtros = true
      this.obtenerDataAsignaciones()
      this.obtenerResponsivas()
      if (this.userLogin.departamento == 1 || this.userLogin.departamento == 3 || this.userLogin.departamento == 6 || this.userLogin.departamento == 2 || this.userLogin.departamento == 4) {
          this.verFirmar = true
        }
    },

    obtenerDataAsignaciones () {
      let ubi = ''
      if (this.almacenSelect === '' || this.almacenSelect === 'c') {
        ubi = this.origen.clave
      } else {
        ubi = this.almacenSelect
      }
      InventarioServices.getAsignacion_Almacen(ubi)
        .then(res => {
          this.asignaciones = res.map(this.convertirAsign)
          this.asignacionesSelect = this.asignaciones
          this.asignacionesShow = this.asignacionesSelect
          this.obtenerPuestos()
          this.isLoading = false
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirDocumentos (docto) {
      return {
        ...docto,
        id: parseInt(docto.id),
        tipo: parseInt(docto.tipo),
      }
    },

    convertirAsign (asig) {
      const responsiva = this.responsivas.find( r => r.id_articulo === asig.id_articulo && asig.idRecibe === r.idUsuario)
      return {
        ...asig,
        area: parseInt(asig.area),
        estado: parseInt(asig.estado),
        tipo: parseInt(asig.tipo),
        tipoAdm: parseInt(asig.tipoAdm),
        responsiva: responsiva ? responsiva : '',
        precioUnitario: asig.precioUnitario === '' ?  0 : Number(asig.precioUnitario),
        inAlmacen: false,
      }
    },

    obtenerResponsivas () {
      ResponsivasService.getResponsivas_tipo('All')
        .then( data => {
          this.responsivas = data.map(this.convertirResponsiva)
          this.obtenerOficinas()
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',e.message, 'ban', 'OK')
        })
    },

    convertirResponsiva(resp) {
      return {
        ...resp,
        id: parseInt(resp.id),
        categoria: parseInt(resp.categoria),
        estado: parseInt(resp.estado),
        area: parseInt(resp.area),
        tipo: parseInt(resp.tipo)
      }
    },

    convertOtrasAsignaciones(asig) {
      let descripcion = asig.categoria
      if (asig.subcategoria !== '') {
        descripcion += ` ${asig.subcategoria}`
      }
      if (asig.marca !== '') {
        descripcion += ` ${asig.marca}`
      }
      if (asig.modelo !== '') {
        descripcion += ` ${asig.modelo}`
      }
      return {
        ...asig,
        descripcion: descripcion,
        estado: parseInt(asig.estado),
        tipo: parseInt(asig.tipo),
        garantia: parseInt(asig.garantia),
      }
    },

    irAsignacionDetalle (data) {
      if (this.permisos.inventarios == 6) {
        return
      }
      if (this.userLogin.departamento == 1 || this.userLogin.departamento == 3 || this.userLogin.departamento == 6 || this.userLogin.cargo === "321" || this.userLogin.cargo === "323") {
        this.$store.commit('detalleAsignacion', data)
        this.$router.push('/Inventario/Asignacion/Detalle')
      }
    },

    irResguardos (id) {
      if (this.permisos.inventarios == 6) {
        return
      }
      this.$router.push({ path: `/Inventario/Resguardos/${id}` })
    },

    descargarResguardos () {
      this.isLoading = true
      let currentUrl = window.location.hostname

      if (this.showOtros) {
        console.log('Descargar Otras asignaciones')
        InventarioServices.createExcel_Resguardo_Otros(this.query)
          .then((res) => {
            console.log(res)
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
                setTimeout(() => {
                  InventarioServices.borrarFile_InventarioUser(res.file)
                    .then( resDel => {
                      this.isLoading = false
                      console.log(resDel)
                    })
                }, 4000)
              } else {
                this.isLoading = false
                console.log(res.respuesta)
              }
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error}`, 'ban', 'OK')
          })


      } else {
        this.isLoading = true
        if (!this.userNormal) {
          const ubi = this.verOpciones ? this.query : this.userLogin.ubicacion
          InventarioServices.createExcel_Resguardos(ubi, this.userLogin.cargo, this.areaInt, this.areaAdm)
            .then( res => {
              console.log(res)
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
                setTimeout(() => {
                  InventarioServices.borrarFile_InventarioUser(res.file)
                    .then( resDel => {
                      console.log(resDel)
                      this.isLoading = false
                    })
                }, 4000)
              } else {
                this.isLoading = false
                console.log(res.respuesta)
              }
            })
            .catch((e=> {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            }))
        } else {
          
          if (this.verArticulosArea) {
            this.descargarResguardoArea()
          } else {
            this.descargarResguardoIndvidual()
          }

        }
      }

    },

    descargarResguardoArea () {
      let currentUrl = window.location.hostname
      InventarioServices.createExcel_Resguardos(this.userLogin.ubicacion, this.userLogin.cargo)
        .then( res => {
          console.log(res)
          if (res.success) {
            open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
            setTimeout(() => {
              InventarioServices.borrarFile_InventarioUser(res.file)
                .then( resDel => {
                  this.isLoading = false
                  console.log(resDel)
                })
            }, 4000)
          } else {
            this.isLoading = false
            this.displayToast('bubble',res.respuesta, 'ban', 'OK')
          }
        })
        .catch((e=> {
          this.isLoading = false
          this.displayToast('bubble',e.message, 'ban', 'OK')
        }))
    },

    descargarResguardoIndvidual () {
      let currentUrl = window.location.hostname
      
      InventarioServices.createExcel_Resguardo_Usuario(this.userLogin.id, this.userLogin.nombre,this.userLogin.nombre_file)
        .then( res => {
          if (res.success) {
            open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_User.php?nameFile=${res.file}`, '_blank');
            setTimeout(() => {
              InventarioServices.borrarFile_ResguardoUser(res.file)
                .then( resDel => {
                  console.log(resDel)
                })
                this.isLoading = false
            }, 4000)
          } else {
            console.log(res.respuesta)
            this.isLoading = false
          }
        })
    },

    firmar(data, estadoF) {
      if (this.permisos.inventarios == 6) {
        return
      }
      switch (estadoF) {
        case 1:
          if (this.userLogin.id === data.idEntrega) {
            console.log('Pasa a firma del Usuario')
            this.firmarAsignacion(data, estadoF)
          } else {
            console.log('No es el usuario que la creo')
          }
          break
        case 2:
          this.firmarAsignacion(data, estadoF)
          break
        case 3:
          this.firmarAsignacion(data, estadoF)
          break
        default:
          break
      }
    },

    firmarAsignacion(asign, estadoF) {
      if (this.permisos.inventarios == 6) {
        return
      }
      this.isLoading = false
      let myObjAsignacion = {
        id_asignacion: asign.id_asignacion,
        fechaReg: asign.fechaReg,
        id_entrega: asign.idEntrega,
        entrega: asign.entrega,
        id_recibe: asign.idRecibe,
        recibe: asign.recibe,
        area: asign.area,
        origen: asign.origen,
        ubicacion: asign.destino,
        ubicacion_ofi: asign.oficina_Asig,
        estado: estadoF,
        hash: asign.hash
      }

      this.$store.commit('firmarAsignacion', myObjAsignacion)
      this.$router.push('/Inventario/Asignacion/Firma')
    },

    verHistoria (id) {
      this.$router.push({ path: `/Inventario/Historia/${id}` } )
    },

    verHistoriaNumero (numero) {
      this.$router.push({ path: `/Inventario/Numero/${numero}` } )
    },

    backPage () {
      this.$router.back()
    },

    cambiarUbicacion(item) {
      if (this.permisos.inventarios == 6) {
        return
      }
      
      if (this.userLogin.departamento === 3 || this.userLogin.departamento === 1 || this.userLogin.cargo === "321" || this.userLogin.cargo === "323" || this.userLogin.cargo === "324" || this.userLogin.cargo === "241" || this.userLogin.cargo === "372") {
        if (item.origen_ofi === this.origen.clave) {
          this.itemCambiar = item
          this.configModal = {
            title: 'Ubicar equipo',
            content: `Seleccione la ubicación y el estatus de: ${item.descripcion}.`,
            textCancel: 'Cancelar',
            textOk: 'Guardar'
          }
          this.modalStatus = true
        }
      }
    },

    selectNewOffice (result) {
      if (result === 'close') {
        this.modalStatus = false
        return
      }
      this.isLoading = true
      if ( Object.keys(result).length > 0 ) {
        if (result.estatus != 12) {
          let id = Date.now()
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
          const ubi = result.ubicacion ? result.ubicacion : this.itemCambiar.ubicacionArt
          const ofi = result.oficina ? result.oficina : this.itemCambiar.oficinaArt

          let idEntrega = ''
          let entrega = ''
          let idRecibe = ''
          let recibe = ''
          let localizacion = 0
          switch (result.estatus) {
            case 6:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              localizacion = result.id_localizacion
              break
            case 7:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = this.itemCambiar.i_recibe
              recibe = this.itemCambiar.recibe
              break
            case 8:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
            case 9:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              localizacion = result.id_localizacion
              break
            case 10:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              localizacion = result.id_localizacion
              break
            case 11:
              idEntrega = '1538165924968'
              entrega = 'Administrador'
              idRecibe = this.itemCambiar.i_recibe
              recibe = this.itemCambiar.recibe
            case 12:
              idEntrega = '1538165924968'
              entrega = 'Administrador'
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
          }
          
          InventarioServices.addUbicacion(id, this.itemCambiar.id_articulo, fechaReg, ubi, ofi, 
          idEntrega, entrega, idRecibe, recibe, result.estatus)
            .then((data) => {
                InventarioServices.updateLocalizacion(this.itemCambiar.id_articulo, localizacion)
                  .then( dataloc => {
                    if (dataloc.success) {
                      this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
                      this.obtenerDataAsignaciones()
                    } else {
                      this.displayToast('bubble', dataloc.respuesta, 'ban', 'OK')
                    }
                  })
                  .catch( e => {
                    this.isLoading = false
                    this.displayToast('bubble',e.message, 'ban', 'OK')      
                  })
                
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
        } else {
          this.isLoading = false
          this.$store.commit('bajaArticulo', this.itemCambiar.id_articulo)
          this.$router.push('/Inventario/Almacen/Bajas/Nueva')
        }

      }
      this.modalStatus = false
    },

    verModalD (data, tipo) {
      if (this.permisos.inventarios == 6) {
        return
      }
      this.asignacionToModal = data
      this.modalStatusD = true
      this.tipoFileUp = tipo
    },

    verModalResponsiva (data) {
      this.isLoading = true
      let dataResponsiva = []
      console.log(data)
      const documentos =  data.documentos.map(this.convertirDocumentos)
      switch (data.responsiva.categoria) {
        case 0:
          ResponsivasService.getItems_Multiples(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        case 1:
          ResponsivasService.getItems_Computo(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD.map(this.convertirItemComputo)
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        case 2:
          ResponsivasService.getItems_Telefono(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD.map(this.convertirItemTelefono)
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        case 3:
          ResponsivasService.getItems_Combustible(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        case 4:
          ResponsivasService.getItems_Peaje(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        case 5:
          ResponsivasService.getItems_Vehiculos(data.responsiva.nombre_responsiva)
            .then( dataBD => {
              dataResponsiva = dataBD
              this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
              this.isLoading = false
              this.modalStatusResp = true
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
          break
        default:
          dataResponsiva = []
          this.responsivaToModal = this.crearObjResponsivaModal(data.responsiva, dataResponsiva, documentos)
          this.modalStatusResp = true
          break
      }
      
    },

    crearObjResponsivaModal (resp, items, doctos) {
      return {
        ...resp,
        items: items,
        doctos: doctos,
      }
    },

    convertirItemTelefono (tel) {
      return {
        ...tel,
        adaptadorSD: parseInt(tel.adaptadorSD),
        audifonos: parseInt(tel.audifonos),
        caja: parseInt(tel.caja),
        cargador: parseInt(tel.cargador),
        id: parseInt(tel.id),
        protector: parseInt(tel.protector),
        protector: parseInt(tel.protector),
        sim: parseInt(tel.sim),
      }
    },

    convertirItemComputo (item) {
      return {
        ...item,
        id: parseInt(item.id),
        accesorios: parseInt(item.accesorios),
        backpack: parseInt(item.backpack),
        caja: parseInt(item.caja),
        cargador: parseInt(item.cargador),
        funda: parseInt(item.funda),
        mouse: parseInt(item.mouse),
      }
    },

    cerrarModalD () {
      this.asignacionToModal = {}
      this.modalStatusD = false
    },

    displayToast(tema,text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    
    updateUbicacion (data) {
      this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.repsuesta, data.success ? 'done' : 'ban', 'OK')
      this.obtenerDataAsignaciones()
      
    },

    subirDocumento (doctos) {
      this.modalStatusD = false
      this.isLoading = true
      const files = Array.from(doctos)
      if (files.length > 0) {
        var i = 0
        files.forEach(docto => {
          
          const nombreFile = docto.name
          let tipoInt = 0
          if (this.tipoFileUp !== 'facturas') {        
            switch (this.tipoFileUp) {
              case 'images':
                tipoInt = 0
                break
              case 'facturas':
                tipoInt = 1
                break
              case 'polizas':
                tipoInt = 2
                break
              case 'tarjetaCirc':
                tipoInt = 3
                break
            }
            InventarioServices.uploadDocumento(this.asignacionToModal.id_articulo, nombreFile, docto, tipoInt)
              .then(data => {
                if (data.success) { i++}
                
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                if (i== doctos.length) {
                  this.isLoading = false
                  this.obtenerDataAsignaciones()
                }
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })  
          } else {
            InventarioServices.subirFactura(this.asignacionToModal.id_articulo, nombreFile, docto)
              .then( data => {
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                this.isLoading = false
                this.obtenerDataAsignaciones()
              })
              .catch(error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        })
        
      } else {
        this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
        this.isLoading = false
      }
      
    },

    subirDocumentoFromResponsiva (objResp) {
      this.modalStatusResp = false
      this.isLoading = true
      const { files } = objResp
      const filesD = Array.from(files)
      if (filesD.length > 0) {
        filesD.forEach(docto => {
          const nombreFile = docto.name

          InventarioServices.uploadDocumento(this.responsivaToModal.id_articulo, nombreFile, docto, objResp.tipo)
            .then(data => {
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              this.responsivaToModal = {}
              this.obtenerDataAsignaciones()
            })
            .catch( error => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
            })
        })
      } else {
        this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
        this.isLoading = false
      }
    },
    
    verModalDeleteDocumento (docto) {
      
      let title = ''
      let content = ''

      switch (this.tipoFileUp) {
        case 'images':
          title = 'Eliminar Documento'
          content = '¿Desea eliminar el documento?'
          break
        case 'facturas':
          title = 'Eliminar Factura'
          content = '¿Desea eliminar la factura?'
          break
        case 'polizas':
          title = 'Eliminar Póliza'
          content = '¿Desea eliminar la póliza?'
          break
      }

      this.configModalYN = {
        title: title,
        content: content,
        textCancel: 'Cancelar',
        textOk: 'Eliminar'
      }
      this.modalStatusD = false
      this.documentoSelect = docto
      this.modalStatusYN = true
    },

    verModalDeleteDocumentoFromResp (docto) {
      this.configModalYN = {
        title: '¿Desea borrar el documento?',
        content: 'Borrar documento de la responsiva.',
        textCancel: 'Cancelar',
        textOk: 'Eliminar'
      }
      this.modalStatusResp = false
      this.documentoSelect = docto
      this.modalStatusYN = true
      this.isFileResponsiva = true
    },

    borrarDocumento (result) {
      this.modalStatusYN = false
      this.isLoading = true
      if (result) {
        if (!this.isFileResponsiva) {
          if (this.documentoSelect.tipo === 'documento') {
            InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
              .then(data => {
                this.obtenerDataAsignaciones()
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          } else {
            InventarioServices.deleteFactura(this.documentoSelect.id_articulo, this.documentoSelect.rutaFac)
              .then(data => {
                this.obtenerDataAsignaciones()
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        } else {
          InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
            .then(data => {
              this.obtenerDataAsignaciones()
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
            })
            .catch( error => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
            })
        }
      } else {
        this.isLoading = false
        this.modalStatusD = true
      }
      this.documentoSelect = {}
    },
    
    getRuta (ruta) {
      const currentURL = window.location.hostname
      return `https://${currentURL}${ruta}`
    },

    cerrarModalResp () {
      this.responsivaToModal = {}
      this.modalStatusResp = false
    },

    borrarResponsiva () {
      return false
    },

    getDataResp (data) {
      let htmlRes = ''
      switch (data.categoria) {
        case 0:
          htmlRes = `<i class="fas fa-shapes"></i>`
          break
        case 1:
          htmlRes = `<i class="fas fa-laptop"></i>`
          break
        case 2:
          htmlRes = `<i class="fas fa-mobile-alt"></i>`
          break
        case 3:
          htmlRes = `<i class="fas fa-gas-pump"></i>`
          break
        case 4:
          htmlRes = `<i class="fas fa-ticket-alt"></i>`
          break
        case 5:
          htmlRes = `<i class="fas fa-car"></i>`
          break
        default:
          htmlRes = ``
          break
      }
      return htmlRes
    },

    irEditarArticulo(data) {
      if (this.permisos.inventarios == 6) {
        return
      }
      this.$router.push({ path: `/Inventario/ArticuloDetalle/${data.id_articulo}` })
    },

    getClassTipo (asig, tipo) {
      const { documentos } = asig
      const isFiles = documentos.some( d => d.tipo === tipo)
      return isFiles ? 'is-success' : 'is-warning'
    },

    getArticulosAlmacenSubArea() {
      InventarioServices.getArticulosAlmacenSubArea(this.areaAdm)
        .then( data => {
          console.log(data)
          if (data.length > 0) {
            const articulos = data.map(this.convertirArticulosSubArea)
            articulos.map( a => this.asignaciones.push(a))
          }
        })
        .catch((e) => {
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirArticulosSubArea(a) {
      return {
        ...a,
        inAlmacen: true,
        responsiva: '',
        recibe: a.resguardo,
        puesto: 'Almacen',
        destino: a.ubicacion,
        descripcion: `${a.categoria} ${a.subcategoria}`
      }
    },

    verModalPuestos(data) {
      if (this.permisos.inventarios == 6 || this.permisos.inventarios == 4) {
        return
      }
      this.puestoUser = ''
      this.modalStatusPuestos = true
      this.configModalPuestos = {
        title: 'Modificar Puesto',
        content: 'Seleccione un Puesto',
        textCancel: 'Cancelar',
        textOk: 'Actualizar'
      }
      this.puestoUser = data
    },

    obtenerPuestos() {
      UsuariosServices.getPuestos()
        .then( data => {
          this.puestos = data
        })
        .catch( e => {
          console.log('Error en obtener puestos')
        })
    },

    selectNewPuesto(newPuesto) {
      if (newPuesto === 'close') {
        this.modalStatusPuestos = false
        this.configModalPuestos = {}
        return
      }
      this.isLoading = true
      UsuariosServices.updatePuesto(this.puestoUser.idRecibe, newPuesto.id)
        .then( data => {
          this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
          if (data.success) {
            const texto = `Modificó el Puesto ${this.puestoUser.puesto} a ${newPuesto.nombre}`
            const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
            InventarioServices.updateCambios(this.userLogin.id, this.puestoUser.idRecibe, fechaReg, texto)
              .then( data => {
                console.log(data)
              })
              .catch(e => {
                console.log(e.message)
              })
              this.puestoUser = {}
              this.modalStatusPuestos = false
              this.configModalPuestos = {}
              this.iniciarComponente()
          }
        })
        .catch( error => {
          this.isLoading = false
          this.puestoUser = {}
          this.modalStatusPuestos = false
          this.configModalPuestos = {}
          this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
        })
    },

    downloadAsignaciones () {
      this.isLoading = true
      let ubi = ''
      if (this.almacenSelect === '' || this.almacenSelect === 'c') {
        ubi = this.origen.clave
      } else {
        ubi = this.almacenSelect
      }
      InventarioServices.descargarAsignacionesSede(ubi)
        .then((res) => {
          const currentUrl = window.location.hostname
          if (res.success) {
            open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
            setTimeout(() => {
              InventarioServices.borrarFile_InventarioUser(res.file)
                .then( resDel => {
                  this.isLoading = false
                  console.log(resDel)
                })
            }, 4000)
          } else {
            this.isLoading = false
            console.log(res.respuesta)
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${error}`, 'ban', 'OK')
        })
    },
    irSalidas(tipo) {
      this.$store.commit('selectSalida', tipo)
      this.$router.push( {path: '/Inventario/Busqueda'})
    },
    obtenerAlmacenes() {
      InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },
    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
        this.origen = alm
      }
    })
      console.log(this.origen)
      this.getSede()
    },
    getSede() {
      console.log(this.origen.clave)
      switch (this.origen.clave) {
        case 'TPA-ALS':
        this.title = 'Asignaciones de TPA GIA'
        this.sede = 'TPA'
        break
      case 'EB04-ALG':
        this.title = 'Asignaciones de EB04 GIA'
        this.sede = 'EB04'
        break
      case 'CORP-ALG':
        this.title = 'Asignaciones de Corporativo GIA'
        this.sede = 'CORP'
        break
      case 'IRGE-ALM':
        this.title = 'Asignaciones de IRGE'
        this.sede = 'IRGE'
        break
      case 'IRGE-ALA':
        this.title = 'Asignaciones de IRGE Activos'
        this.sede = 'IRGE'
        break
      case 'IRGE-ALE':
        this.title = 'Asignaciones de IRGE Enfermería'
        this.sede = 'IRGE'
        break
      case 'CORP-ALM':
        this.title = 'Asignaciones de Corporativo'
        this.sede = 'CORP'
        break
      case 'TPA-ALM':
        this.title = 'Asignaciones de TPA'
        this.sede = 'TPA'
        break
      case 'EB04-ALM':
        this.title = 'Asignaciones de EB04'
        this.sede = 'EB04'
        break
      case 'EB00-ALM':
        this.title = 'Asignaciones de EB00'
        this.sede = 'EB00'
        break
      case 'EB01-ALM':
        this.title = 'Asignaciones de EB01'
        this.sede = 'EB01'
        break
      case 'EB02-ALM':
        this.title = 'Asignaciones de EB02'
        this.sede = 'EB02'
        break
      case 'EB03-ALM':
        this.title = 'Asignaciones de EB03'
        this.sede = 'EB03'
        break
      case 'ERM-ALM':
        this.title = 'Asignaciones de ERM'
        this.sede = 'ERM'
        break
      }
      this.iniciarComponente()
    },
    printAsignacion(data) {
      const currentUrl = window.location.hostname
      const almacen = this.almacenes.find( a => a.clave === data.origen_ofi)
      const idAlm = almacen ? almacen.id_oficina : 0
      let link = `https://${currentUrl}/servidores/reportes/inventarios/asignacionI.php?idAsig=${data.id_asignacion}&alm=${idAlm}`
      if (!open(link)) {
        console.log('Error abriendo archivo')
      }
    },
    obtenerOficinas() {
      InventarioServices.getOficinas()
        .then( data => {
          this.oficinas = data.map(this.convertirOficinas)
          this.obtenerEstados()
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
    },

    convertirOficinas(ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        oficina: ofi.nombre,
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },

    obtenerEstados() {
      InventarioServices.getEstadosUso()
        .then( data => {
          this.estadosDB = data.map(this.convertirEstadosUso)
          this.obtenerLocalizaciones()
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
    },

    convertirEstadosUso(est) {
      return {
        ...est,
        id: parseInt(est.id)
      }
    },
    
    obtenerLocalizaciones() {
      InventarioServices.getLocalizaciones()
        .then( data => {
          this.localizaciones = data.map(this.convertirLocalizaciones)
          this.obtenerUsuarios()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirLocalizaciones(loc) {
      return {
        ...loc,
        id: parseInt(loc.id),
        id_oficina: parseInt(loc.id_oficina),
      }
    },

    obtenerUsuarios () {
      if (this.permisos.responsivas == 2) {
        return
      }

      if (this.permisos.responsivas == 1 || this.permisos.responsivas == 6) {
        UsuariosServices.getUsuarios()
          .then( (res) => {
              if (res.length > 0) {
                const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
                this.usuarios = usersSort.map(this.convertirDataUsuarios)
              } else {
                this.displayToast('No hay datos', 'ban', 'OK')
                this.isLoading = false
              }  
            })
            .catch((error) => {
              this.isLoading = false
              this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
            })
        return
      }

      if (this.permisos.responsivas == 5) {
        UsuariosServices.getUsuarios_Ubicacion(this.userLogin.ubicacion)
          .then( (res) => {
            const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
            this.usuarios = usersSort.map(this.convertirDataUsuarios)
          })
          .catch((e) => {
            this.displayToast(e.message, 'ban', 'OK')
          })
        return
      }

      if (this.permisos.responsivas == 7) {
        UsuariosServices.getUsuarios_SeI()
          .then( (res) => {
            if (res.length > 0) {
              const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
              this.usuarios = usersSort.map(this.convertirDataUsuarios)
            } else {
              this.displayToast('No hay datos', 'ban', 'OK')
              this.isLoading = false
            }  
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
        return
      }

      if (this.permisos.responsivas == 8) {
        UsuariosServices.getUsuarios_Ducto()
          .then( (res) => {
            if (res.length > 0) {
              const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
              this.usuarios = usersSort.map(this.convertirDataUsuarios)
            } else {
              this.displayToast('No hay datos', 'ban', 'OK')
              this.isLoading = false
            }  
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
        return
      }
    },

    convertirDataUsuarios(user) {
      return {
        ...user,
        categoria: parseInt(user.categoria),
        departamento: parseInt(user.departamento),
        jefeArea: parseInt(user.jefeArea)
      }
    },

    cambiarEntrega(user) {
      if (Object.keys(user).length > 0) {
        ResponsivasService.updateEntregaResponsiva(this.responsivaToModal.id, user.id, user.nombre)
          .then( res => {
            this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'OK')
            this.iniciarComponente()
            this.modalStatusResp = false
          })
          .catch( e => {
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      }
    },
  },

  created () {
    switch (this.almacenSelect) {
      case 'TPA-ALS':
        this.title = 'Asignaciones de TPA GIA'
        this.sede = 'TPA'
        this.iniciarComponente()
        break
      case 'EB04-ALG':
        this.title = 'Asignaciones de EB04 GIA'
        this.sede = 'EB04'
        this.iniciarComponente()
        break
      case 'CORP-ALG':
        this.title = 'Asignaciones de Corporativo GIA'
        this.sede = 'CORP'
        this.iniciarComponente()
        break
      case 'IRGE-ALM':
        this.title = 'Asignaciones de IRGE'
        this.sede = 'IRGE'
        this.iniciarComponente()
        break
      case 'IRGE-ALE':
        this.title = 'Asignaciones de IRGE Enfermería'
        this.sede = 'IRGE'
        this.iniciarComponente()
        break
      case 'IRGE-ALA':
        this.title = 'Asignaciones de IRGE Activos'
        this.sede = 'IRGE'
        this.iniciarComponente()
        break
      case 'CORP-ALM':
        this.title = 'Asignaciones de Corporativo'
        this.sede = 'CORP'
        this.iniciarComponente()
        break
      case 'TPA-ALM':
        this.title = 'Asignaciones de TPA'
        this.sede = 'TPA'
        this.iniciarComponente()
        break
      case 'EB04-ALM':
        this.title = 'Asignaciones de EB04'
        this.sede = 'EB04'
        this.iniciarComponente()
        break
      case 'EB00-ALM':
        this.title = 'Asignaciones de EB00'
        this.sede = 'EB00'
        this.iniciarComponente()
        break
      case 'EB01-ALM':
        this.title = 'Asignaciones de EB01'
        this.sede = 'EB01'
        this.iniciarComponente()
        break
      case 'EB02-ALM':
        this.title = 'Asignaciones de EB02'
        this.sede = 'EB02'
        this.iniciarComponente()
        break
      case 'EB03-ALM':
        this.title = 'Asignaciones de EB03'
        this.sede = 'EB03'
        this.iniciarComponente()
        break
      case 'ERM-ALM':
        this.title = 'Asignaciones de ERM'
        this.sede = 'ERM'
        this.iniciarComponente()
        break
      default :
        this.obtenerAlmacenes()
        break
      }
  },
  
  computed: {
    ...mapState(['userLogin', 'almacenSelect', 'permisos'])
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.modalStatus = false // how to hide any open modal?
        this.modalStatusD = false
      }
    })
  }
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 150px;
  }

  .table-responsive {
    overflow-x: auto;
    margin: 10px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListaAsignaciones.vue